import type { AppInboxToastStateItem } from '@src/components/GlobalToasts/AppInboxToast';
import type { MinimalSubscriptionResponse } from '@talos/kyoko';
import { useMemo } from 'react';
import type { Observable } from 'rxjs';
import { map, pipe, type UnaryFunction } from 'rxjs';
import type { AppNotification } from '../../../providers/AppNotifications/AppNotificationsMonitorContainer';
import { getNotificationRenderInfo } from '../../../providers/AppNotifications/getNotificationRenderInfo';

export interface NotificationWithToastInfo {
  rowID: string;
  notification: AppNotification;
  toastInfo?: AppInboxToastStateItem;
}

export function useEnrichNotificationsPipe() {
  const enrichNotificationsPipe = useMemo((): UnaryFunction<
    Observable<MinimalSubscriptionResponse<AppNotification>>,
    Observable<MinimalSubscriptionResponse<NotificationWithToastInfo>>
  > => {
    return pipe(
      map(
        (msg: MinimalSubscriptionResponse<AppNotification>): MinimalSubscriptionResponse<NotificationWithToastInfo> => {
          return {
            ...msg,
            data: msg.data.map(notification => {
              return {
                rowID: notification.NotificationID,
                notification,
                toastInfo: getNotificationRenderInfo(notification, false),
              };
            }),
          };
        }
      )
    );
  }, []);

  return enrichNotificationsPipe;
}
